import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

import { useQueryTimelineAndDensity } from 'api/queries/timelineAndDensity.query';

import {
    FilterLabels,
    FilterNames,
    getFiltersData,
} from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

export const useTimelineAndDensityProvider = ({ widgetId, localFilters }) => {
    const isInPinboard = Boolean(widgetId);
    const globalFilterData = useGlobalFilterDataStore((state) => state.globalFilterData);
    const source = isInPinboard ? localFilters : globalFilterData;

    return {
        ui: {
            state: getState(source),
            pills: useGetPills(source, widgetId),
        },
        api: {
            getTimelineAndDensity: useQueryTimelineAndDensity(getTimelineAndDensityPayload(source)),
        },
    };
};

const useGetPills = (source, widgetId) => {
    const pillsData = {
        [FilterLabels.TAG_PORTFOLIO_BOARD]: source?.programTags?.map((item) => item.value),
    };

    const { pillsList: pills } = useGlobalFiltersHook({
        widgetId,
        latestVersionId: undefined,
        source: pillsData,
    });

    return pills;
};

const getTimelineAndDensityPayload = (source) => {
    return {
        filter: {
            filters: getFiltersData({
                [FilterNames.TAG_PORTFOLIO_BOARD]: source?.programTags?.map((item) => item.value),
            }),
        },
    };
};

const getState = (source) => {
    return {
        //global
        programTags: source?.programTags,
    };
};
